/*
 * @Description: file content
 * @Author: ywl
 * @Date: 2021-03-05 09:42:51
 * @LastEditors: ywl
 * @LastEditTime: 2021-03-27 14:25:38
 */
import axios from "axios";
import store from "../store/index";
import router from "../router/index";
import { Message } from "element-ui";
import { getBaseUrl } from "@/utils/getHost";
let baseURL = getBaseUrl();
const instance = axios.create({
  baseURL, // 配置接口地址
  timeout: 600000,
  withCredentials: false,
});
// instance.defaults.onDownloadProgress = function (progressEvent) {
//   // downloadProgress(progressEvent)
// }
const token = "token";

// 请求拦截
instance.interceptors.request.use(
  (config) => {
    // 一般使用这里来设置请求头里面带token
    if (store.getters["user/isLogin"]()) {
      config.headers[token] = store.getters["user/getToken"]();
    }
    return config;
  },
  (err) => Promise.reject(err)
);

// 响应拦截
instance.interceptors.response.use(
  (response) => {
    // console.log('response', response)

    if (response.data.resultCode === "200") {
      // 处理code=200的业务 代表请求成功
      return Promise.resolve(response.data.data);
    } else {
      // 处理code非200的业务 代表请求失败
      if (response.data.resultCode === "401") {
        store.dispatch("user/logout").then(() => {
          router.push("/login");
        });
        Message.error(response.data.resultMsg || "token失效");
        return Promise.reject(response.data.message);
      } else {
        Message.error(response.data.resultMsg || "系统处理出错");
        return Promise.reject(response.data);
      }
    }
  },
  (err) => Promise.reject(err)
);

export default instance;
